import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import { OrderReceiptResponse } from '@models/order';

import ReceiptDivider from '../ReceiptDivider';

interface Props {
    receipt: OrderReceiptResponse;
}

function Amount({ receipt }:Props) {
  const { order } = receipt;
  const {
    paymentAmount, totalAmount, couponDiscount, vatAmount,
  } = order;
  return (<Column fullWidth>
      <Column fullWidth spacing={2}>
          <Row fullWidth justify='space-between'>
              <Text>합계</Text>
              <Text>{totalAmount.toLocaleString()}</Text>
          </Row>
          {(couponDiscount !== 0) && (
              <Row fullWidth justify='space-between'>
                  <Text>쿠폰</Text>
                  <Text>{couponDiscount.toLocaleString()}</Text>
              </Row>
          )}
      </Column>
      <ReceiptDivider/>
      <Column spacing={2} fullWidth>
          <Row fullWidth justify='space-between'>
              <Text size='2xl' fontWeight='bold'>결제금액</Text>
              <Text size='2xl' fontWeight='bold'>
                  {paymentAmount.toLocaleString()}
              </Text>
          </Row>
          <Row fullWidth justify='space-between'>
              <Text size='lg'>(부가세 포함)</Text>
              <Text size='lg'>{vatAmount.toLocaleString()}</Text>
          </Row>
      </Column>
      <ReceiptDivider/>
  </Column>);
}

export default Amount;
